import React from 'react'

import scrollToElement from 'scroll-to-element'
import cartData from './../models/cart.js'

export class CartHeaderComponent extends React.Component {
  constructor(props) {
    super(props)
    this.toOrder = this.toOrder.bind(this)
    this.clearCart = this.clearCart.bind(this)
    cartData.subject
      .subscribe(()=> {
        this.forceUpdate()
      })
  }

  toOrder() {
    scrollToElement('.make-order');
  }

  clearCart() {
    if(confirm('Очистить?')) {
      cartData.clear()
    }
  }

  render() {
    let c = cartData
    if(c.orderMade) {
      return (
        <div className="catalog-top__info">
          <div className="h1">Ваш заказ оформлен!</div>
          <div className="h1-descr">
            Спасибо!
          </div>
        </div>
      )
    }
    if(c.cartTotalItems()) {
      return (
        <div className="catalog-top__info">
          <div className="h1">Корзина</div>
          <div className="h1-descr">
            Подтвердите содержание корзины и оформите заказ
          </div>
          <button className="btn btn--red mt-30" onClick={this.toOrder}>
            Оформить заказ
          </button>

          <button className="btn btn--blue mt-30" onClick={this.clearCart}>
            Очистить корзину
          </button>
        </div>
      )
    }

    return (
      <div className="catalog-top__info">
        <div className="h1">Корзина</div>
        <div className="h1-descr">
          Корзина пуста
        </div>
      </div>
    )

  }
}



// WEBPACK FOOTER //
// ./app/javascript/website_default/js/react/cart/cart_header/cart_header.component.jsx